module.exports = __webpack_public_path__ + "static/media/NETS_Contact.2742f119.png";